import type { FC } from "react";
import { Stack } from "@mantine/core";
import { IconShieldCheck } from "@tabler/icons-react";
import {
  FileType,
  type File,
  type Order,
  getTraceabilitiesFile,
} from "@jasper/shared";
import type { OrderPageState } from "../useOrderPage";
import { OrderDetailCard } from "./OrderDetailCard";
import { OrderFileRow } from "./OrderFileRow";
import { formatDayMonth, getFileExtension } from "./order-page-v2.utils";

const getTraceabilityFileLabel = (file: File): string =>
  (file.fileType ?? file.name)?.toUpperCase() ===
  FileType.BILLING_PATIENT_TRACEABILITY
    ? "Fiche patient"
    : "Fiche praticien";

type OrderTraceabilityCardProps = {
  order: Order;
  state: OrderPageState;
};

export const OrderTraceabilityCard: FC<OrderTraceabilityCardProps> = ({
  order,
  state,
}) => {
  const traceabilityFiles = getTraceabilitiesFile(order.files ?? []);

  if (traceabilityFiles.length === 0) {
    return null;
  }

  return (
    <OrderDetailCard
      icon={IconShieldCheck}
      iconColor="emerald"
      title="Traçabilité"
    >
      <Stack gap="s2">
        {traceabilityFiles.map(file => (
          <OrderFileRow
            key={file.id}
            name={getTraceabilityFileLabel(file)}
            extension={getFileExtension(file.key)}
            meta={`Ajoutée le ${formatDayMonth(new Date(file.createdAt))}`}
            onDownload={() => state.actions.downloadFile(file)}
          />
        ))}
      </Stack>
    </OrderDetailCard>
  );
};
